// src/pages/ProfilePage.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import EditProfileForm from '../components/EditProfileForm';
import { useAuth } from '../context/AuthContext';
import { isAdminAuthor } from '../utils/adminUtils';
import { Button, ButtonLink, GridCol, GridRow, Page, PageHeader, PageStatus } from '../components/ui';

const ProfilePage: React.FC = () => {
  const { author, token } = useAuth();
  const navigate = useNavigate(); // Initialize useNavigate
  const canAccessAdminTools = isAdminAuthor(author);

  const handleGoBack = () => {
    navigate(-1); // Go back to the previous page
  };

  // Le composant App.tsx gère déjà les états de chargement et d'erreur.
  // Si nous sommes ici, l'auteur est forcément chargé.
  if (!author || !token) {
    return (
      <PageStatus marginTop={4} alertVariant="warning">
        Impossible de charger les informations du profil.
      </PageStatus>
    );
  }

  return (
    <Page marginTop={4} paddingBottom={5}>
      <PageHeader justify="start">
        <Button variant="secondary" onClick={handleGoBack}>
          Retour
        </Button>
        {canAccessAdminTools && (
          <ButtonLink to="/admin/notifications" variant="primary" outline>
            Admin notifications
          </ButtonLink>
        )}
      </PageHeader>
      <GridRow justify="center">
        <GridCol md={8} lg={6}>
          <EditProfileForm author={author} token={token} />
        </GridCol>
      </GridRow>
    </Page>
  );
};

export default ProfilePage;
